import PropTypes from 'prop-types';

import { navigation } from '@constants';
import { Flex } from '../grid';
import { P, Label } from '../typography/new';
import { ActiveDot } from '../active-dot';

// One tracking CTA per active delivery type. Regular delivery links to the standard orders page,
// catering delivery to the catering orders page. When both a regular and a catering order are in
// progress, both CTAs render side by side (8px gap).
const TrackLink = ({ href, children }) => (
  <Flex as="a" href={href} gap="8px" color="white" alignItems="center">
    <P variant="text-link" mb={{ lg: '3px' }}>
      {children}
    </P>
  </Flex>
);

TrackLink.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

const OrderInProgressBanner = ({ regularOrderCount, cateringOrderCount }) => {
  const totalCount = regularOrderCount + cateringOrderCount;

  return (
    <Flex
      justifyContent="center"
      py="16px"
      alignItems="center"
      height="56px"
      background="#E81313"
      width="100vw"
      gap="24px"
      position="absolute"
      top="0"
      zIndex="50"
    >
      <Flex gap="8px" color="white" alignItems="center">
        <ActiveDot color="white" />

        <Label>{`${totalCount > 1 ? `${totalCount} ` : ''}ORDER${totalCount > 1 ? 'S' : ''} IN PROGRESS`}</Label>
      </Flex>

      <Flex gap="8px" alignItems="center">
        {regularOrderCount > 0 && (
          <TrackLink href={navigation.ORDERS}>
            {regularOrderCount > 1 ? 'View regular orders' : 'Track regular order'}
          </TrackLink>
        )}
        {cateringOrderCount > 0 && (
          <TrackLink href={navigation.CATERING_ORDERS}>
            {cateringOrderCount > 1 ? 'View Catering orders' : 'Track Catering order'}
          </TrackLink>
        )}
      </Flex>
    </Flex>
  );
};

OrderInProgressBanner.propTypes = {
  regularOrderCount: PropTypes.number,
  cateringOrderCount: PropTypes.number,
};

OrderInProgressBanner.defaultProps = {
  regularOrderCount: 0,
  cateringOrderCount: 0,
};

export { OrderInProgressBanner };
